export const millisToSeconds = (millis: string): number => {
  return parseFloat(millis) / 1000;
};
